
import React, { useState, useRef } from 'react';
import Layout from 'Layout'
import { Collapse, QRCode, Modal } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import './styles.scss'
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const AccountSecurityoPage: React.FC = () => {
    const [f2a, setF2a] = useState(false);
    const { t } = useTranslation();
    return (
        <Layout>
            <>
                <nav className="breadcrumb__container mb-3">
                    <div className="breadcrumb__gradient breadcrumb__gradient--left" data-gradient="left" style={{ display: 'none' }}></div>
                    <ul className="breadcrumb" data-breadcrumb-scroll-container="">
                        <li className="breadcrumb-item"><a href="/accounts-overview">{t('Trader')}</a></li>
                        <li className="breadcrumb-item ">
                            <a href="/profile">
                                {t('Profile')}
                            </a>
                        </li>
                        <li className="breadcrumb-item active">{t('PersonalInformation')}</li>
                    </ul>
                    <div className="breadcrumb__gradient breadcrumb__gradient--right" data-gradient="right" style={{ display: 'none' }}></div>
                </nav>

                <div className="section-header mb-4">
                    <div className="section-title">
                        <div className="section-title__title-wrap">
                            <div className="section-title__icon">
                                <i className="fi fi--user fi--themed"></i>
                            </div>
                            <div className="section-title--main">{t('Profile')}</div>
                        </div>
                    </div>
                    <div className="section-header__tabs">
                        <ul className="nav nav-tabs">
                            <li className="nav-item">
                                <a href="/profile" className="nav-link ">
                                    <span className="nav-link__label">{t('PersonalInformation')}</span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/profile/account" className="nav-link ">
                                    <span className="nav-link__label">{t('AccountInformation')}</span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/profile/security" className="nav-link active">
                                    <span className="nav-link__label">{t('Security')}</span>
                                </a>
                            </li>
                            {/* <li className="nav-item">
                                <a href="/profile/teams" className="nav-link ">
                                    <span className="nav-link__label">{t('Teams')}</span>
                                </a>
                            </li> */}
                            <li className="nav-item">
                                <a href="/profile/affiliate" className="nav-link ">
                                    <span className="nav-link__label">{t('Affiliates')}</span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/profile/inventory" className="nav-link ">
                                    <span className="nav-link__label">{t('Inventory')}</span>
                                </a>
                            </li>
                            <li className="nav-item" style={{ pointerEvents: 'none', cursor: 'default', color: 'gray', opacity: '0.6' }}>
                                <a href="#" data-notification-target="nav-profile-identity" className="nav-link disabled" tabIndex={-1} aria-disabled="true">
                                    <span className="nav-link__label">{t('LUMIRIdentity')}</span>
                                </a>
                            </li>
                            <li className="nav-item" style={{ pointerEvents: 'none', cursor: 'default', color: 'gray', opacity: '0.6' }}>
                                <a href="#" className="nav-link disabled" tabIndex={-1} aria-disabled="true">
                                    <span className="nav-link__label">{t('EmailNewsletters')}</span>
                                </a>
                            </li>
                            <li className="nav-item" style={{ pointerEvents: 'none', cursor: 'default', color: 'gray', opacity: '0.6' }}>
                                <a href="#" className="nav-link disabled" tabIndex={-1} aria-disabled="true">
                                    <span className="nav-link__label">{t('LUMIRPoints')}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div style={{ pointerEvents: 'none', opacity: 0.6 }}>
                    <Collapse
                        size="large"
                        expandIconPosition="right"
                        ghost
                        className="mb-3 shadow-sm"
                        style={{ backgroundColor: '#fff' }}
                        expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? -180 : 0} />}
                        items={[{
                            key: '1',
                            label: <TwoFactorLable active={f2a} />,
                            children: <TwoFactorAuth
                                isEnabled={f2a}
                                setIsEnabled={(e) =>
                                    setF2a(e)
                                } />
                        }]}
                    />
                </div>
                <Collapse
                    size="large"
                    expandIconPosition="right"
                    ghost
                    className='mb-3 shadow-sm'
                    style={{ backgroundColor: '#fff' }}
                    expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? -180 : 0} />}
                    items={[{ key: '1', label: <ChangePasswordLabel />, children: <ChangePassword /> }]}
                />

                <div className="footer mb-5 mb-md-auto">
                    <div className="row my-4 small">
                        <div className="col-12 small text-center text-md-end mb-md-1 mb-2 fw-bold">
                            <a href="#" id="ftmo-cookie-settings" className=""> {t('CookieSettings')} </a>
                            &nbsp;
                            <a href="#" data-bs-toggle="modal" data-bs-target="#modal_privacy_policy"> {t('PrivacyPolicy')} </a>
                            &nbsp;
                            <a href="#" id="footer__link-terms-conditions"> {t('TermsConditions')} </a>
                        </div>

                        <div className="col-12 small">
                            <div className="col-12 small">
                                <p className="text-justify">
                                    {t('disclaimerFull')}
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </>
        </Layout>
    );
}

export default AccountSecurityoPage;
const TwoFactorLable = ({ active }: { active: boolean }) => {
    const { t } = useTranslation();
    return (
        <div className="two-fa-auth__label">
            <span className="two-fa-auth__label-text">{t('2FAFull')}</span>
            {
                active ? (
                    <span className="ms-3 badge bg-success">{t('Enabled')}</span>
                ) : (
                    <span className="ms-3 badge bg-danger">{t("Disabled")}</span>
                )
            }
        </div>
    );
}
type TwoFactorAuthProps = {
    isEnabled: boolean;
    setIsEnabled: (e: boolean) => void;
};

const TwoFactorAuth: React.FC<TwoFactorAuthProps> = ({ isEnabled, setIsEnabled }) => {
    const [deviceList, setDeviceList] = useState<{ name: string, date: Date }[]>([]);
    const { t } = useTranslation();
    function addDevice(name: string) {
        const newDevice = { name, date: new Date() };
        setDeviceList((prevDevices) => [...prevDevices, newDevice]);
        toast.success('Device added successfully!');
    }

    function removeDevice(index: number) {
        setDeviceList((prevDevices) => prevDevices.filter((_, i) => i !== index));
        toast.success('Device removed successfully!');
    }
    return (
        <div>
            <div className="row mb-3 pb-3 border-bottom">
                <div className="col-12 mb-2">
                    <div className="alert alert--info">
                        <div className="alert__content">
                            <div className="alert__content-body">
                                <div>{t('2FADesc')}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-lg-8 align-self-center">
                    {t('signin2fa')}
                </div>
                <div className="col-12 col-lg-4 mt-2 mt-lg-0 text-lg-end">
                    <Modal2FAActive
                        active={isEnabled}
                        addDivece={addDevice}
                        setIsActive={
                            (isActive: boolean) => {
                                setIsEnabled(isActive);
                                if (isActive) {
                                    // Logic to handle activation
                                    console.log('2FA Activated');
                                }
                            }
                        } />
                </div>
            </div>
            <div className="two-fa-auth__devices">
                <div className="row mb-3">
                    <div className="col-12 col-md-8 text--semi-bold">
                        {t('Authenticatordevices')}
                    </div>
                    <div className="col-12 col-md-4 text-md-end">
                    </div>
                </div>
                {
                    deviceList.length > 0 ? (
                        <div className="two-fa-auth__device-list">
                            {deviceList.map((device, index) => (
                                <div className="row two-fa-auth__devices-row py-2" key={index}>
                                    <div className="col-12 col-md-5">
                                        <span className="fw-semibold">
                                            {t('Devicename')}:
                                        </span>
                                        {device.name}
                                    </div>
                                    <div className="col-12 col-md-5">
                                        <span className="fw-semibold">
                                            {t('Added')}:
                                        </span>
                                        <span>
                                            {new Intl.DateTimeFormat('en-US', {
                                                year: 'numeric',
                                                month: '2-digit',
                                                day: '2-digit',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                second: '2-digit'
                                            }).format(device.date)}
                                        </span>
                                        <i className="fi fi--timer fi--tooltip date__tooltip ms-1 cursor-pointer" data-bs-toggle="tooltip" data-bs-html="true" data-bs-placement="top" data-date-format="en_US" data-prefix="In your timezone:" data-original-time="2025-07-02 12:00:40" data-bs-original-title="2 Jul 2025 12:00:40"></i>
                                    </div>
                                    <div className="col-12 col-md-2 text-md-end">
                                        <div onClick={
                                            (e: React.MouseEvent<HTMLDivElement>) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                removeDevice(index);
                                            }}
                                            className="link-danger cursor-pointer text-decoration-none"
                                            data-bs-toggle="modal"
                                            data-bs-target="#modal_2fa_remove_last_device">
                                            {t("Remove")}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div id="twoFaNoDevices" className="">
                            <div className="alert alert--secondary">
                                <div className="alert__content">
                                    <div className="alert__content-header">
                                        <div className="alert__icon">
                                            <i className="fi fi--challenge-exclamation"></i>
                                        </div>
                                    </div>
                                    <div className="alert__content-body">
                                        <div>{t('noDevices')}</div>
                                    </div>
                                </div>
                                <div className="alert__button">
                                    <F2AAddDevide
                                        type='add'
                                        setActive={(e: boolean) => setIsEnabled(e)}
                                        addDevice={addDevice}
                                        disabled={isEnabled}
                                    />
                                </div>
                            </div>
                        </div>
                    )
                }

            </div>
        </div>
    );
}

const ChangePasswordLabel: React.FC = () => {
    const { t } = useTranslation();
    return (
        <div className="change-password__label">
            <span className="change-password__label-text">{t('ChangePassword')}</span>
        </div>
    );
}
const ChangePassword: React.FC = () => {
    const { t } = useTranslation();
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const handleChangePassword = () => {
        if (newPassword !== confirmPassword) {
            toast.error('New password and confirm password do not match!');
            return;
        }


        // Reset the form fields after submission
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
        toast.success('Password changed successfully!');
    };

    return (
        <div>
            <form onSubmit={handleChangePassword}>
                <div className="mb-3">
                    <label htmlFor="currentPassword" className="form-label">{t('CurrentPassword')}</label>
                    <input type="password" className="form-control" id="currentPassword" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} required />
                </div>
                <div className="mb-3">
                    <label htmlFor="newPassword" className="form-label">{t('NewPassword')}</label>
                    <input type="password" className="form-control" id="newPassword" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required />
                </div>
                <div className="mb-3">
                    <label htmlFor="confirmPassword" className="form-label">{t('ConfirmNewPassword')}</label>
                    <input type="password" className="form-control" id="confirmPassword" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
                </div>
                <button type="submit" className="btn btn-primary">{t('ChangePassword')}</button>
            </form>
        </div>
    );
}

interface Modal2FAActiveProps {
    active?: boolean;
    setIsActive?: (e: boolean) => void;
    addDivece?: (name: string) => void;
}
const Modal2FAActive: React.FC<Modal2FAActiveProps> = ({ active, setIsActive, addDivece }) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [showAddDevide, setShowAddDevide] = useState(false);
    const [title, setTitle] = useState('Tải xuống ứng dụng Trình xác thực');

    const showModal = () => {
        if (!active) {
            setOpen(true);
        }
    };

    const handleOk = () => {
        setConfirmLoading(true);

        setTimeout(() => {
            setShowAddDevide(true);
            setTitle('Thêm thiết bị xác thực');
            setConfirmLoading(false);
        }, 2000);
    };
    const handleCancel = () => {
        setOpen(false);
    };
    const onClose = () => {
        setOpen(false);
        setShowAddDevide(false);
        if (setIsActive) {
            setIsActive(true);
            toast.success('Two-Factor Authentication activated successfully!');
        }
    };

    return (
        <>
            {active ? (
                <div className="btn btn-sm btn-danger " onClick={() => {
                    if (setIsActive) {
                        setIsActive(false);
                        toast.success('Two-Factor Authentication deactivated successfully!');
                    }
                }}>
                    {t('Deactivated')}
                </div>
            ) : (
                <div className={`btn btn-sm btn-primary`} data-bs-toggle="modal" data-bs-target="#modal_2fa_add_activate" onClick={showModal} >
                    {t("Activate")}
                </div>
            )}

            <Modal
                title={
                    <div className="text-lg font-semibold text-gray-800">
                        {title}
                    </div>
                }
                centered
                onCancel={handleCancel}
                confirmLoading={confirmLoading}
                open={open}
                footer={null}
                width={{
                    xs: '90%',
                    sm: '80%',
                    md: '650%',
                    lg: '50%',
                    xl: '50%',
                    xxl: '40%',
                }}
            >
                <div className="w-full mx-auto bg-white shadow-md rounded-md p-3">
                    <p className="text-sm text-gray-600 mb-6">
                        {t('Activate2FADecs')}
                    </p>

                    <div className="grid grid-cols-2 gap-4 justify-center items-center">
                        <div className="flex flex-col items-center">
                            <QRCode
                                className='w-40 h-40'
                                errorLevel="H"
                                value="https://apps.apple.com/us/app/google-authenticator/id388497605"
                            />
                            <a href="#" className="text-sm text-blue-600 underline mt-2">{t('App_Store')}</a>
                        </div>

                        <div className="flex flex-col items-center">
                            <QRCode
                                errorLevel="H"
                                className='w-40 h-40'
                                value="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en"
                            />
                            <a href="#" className="text-sm text-blue-600 underline mt-2">{t('Google_Play')}</a>
                        </div>
                    </div>

                    <p className="text-sm text-gray-600 mt-6">
                        {t('2fAStep1')}
                    </p>

                    <div className="mt-6 flex justify-between">
                        <button className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 text-sm font-medium" onClick={handleCancel} disabled={confirmLoading}>
                            {t("Cancel")}
                        </button>
                        <F2AAddDevide type='activeF2A' onClick={onClose} disabled={confirmLoading || active}
                            addDevice={(addDivece && addDivece) || (() => { })}
                        />
                    </div>
                </div>
            </Modal>

        </>
    );
}

interface F2AAddDevideProps {
    type: 'add' | 'edit' | 'activeF2A';
    addDevice?: (name: string) => void;
    setActive?: (e: boolean) => void;
    onClose?: () => void;
    onClick?: () => void;
    disabled?: boolean;
}
const F2AAddDevide: React.FC<F2AAddDevideProps> = ({ type, addDevice, setActive, onClose, onClick, disabled }) => {

    const [deviceName, setDeviceName] = useState('');
    const [otpCode, setOtpCode] = useState('');
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const { t } = useTranslation();
    const mail = "testMail@gmail.com"
    const getRandomAuthUrl = (email: string): string => {
        // Generate a random 32-character base32 secret
        const randomBase32 = () => {
            const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567';
            let secret = '';
            for (let i = 0; i < 32; i++) {
                secret += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return secret;
        };

        const encodedEmail = encodeURIComponent(email);
        const secret = randomBase32();
        return `otpauth://totp/LUMIR:${encodedEmail}?secret=${secret}&digits=6&algorithm=SHA1&issuer=LUMIR&period=30`;
    };
    const handleCancel = () => {
        setOpen(false);
        setDeviceName('');
        setOtpCode('');
        onClose && onClose();
    };
    const title = type === 'add' ? t('2faAddDevice') : type === 'edit' ? t('2faEditDevice') : t('2faActivedDevice');
    const handleSubmit = (e: React.FormEvent) => {

        e.preventDefault();
        setTimeout(() => {
            setConfirmLoading(false);
            setOpen(false);
            setDeviceName('');
            setOtpCode('');
            setActive && setActive(true);
            setConfirmLoading(true);
            console.log('Device:', deviceName, 'OTP:', otpCode);
            if (addDevice) {
                addDevice(deviceName);
            }
            onClose && onClose();
            toast.success('Device added successfully!');
        }, 2000);
    };


    return (
        type === 'add' ? (
            <>
                <a href="#" className="btn btn-sm btn-secondary ms-2" data-bs-toggle="modal" data-bs-target="#modal_2fa_add" onClick={() => {
                    setOpen(true);
                    setDeviceName('');
                    setOtpCode('');
                }}>
                    {t('Addnew')}
                </a>
                <Modal
                    title={
                        <div className="text-lg font-semibold text-gray-800">
                            {title}
                        </div>
                    }
                    centered
                    onCancel={handleCancel}
                    confirmLoading={confirmLoading}
                    open={open}
                    footer={null}
                    width={{
                        xs: '90%',
                        sm: '80%',
                        md: '650%',
                        lg: '50%',
                        xl: '50%',
                        xxl: '40%',
                    }}
                >
                    <div className="w-full mx-auto bg-white shadow-md rounded-md p-3">

                        <form onSubmit={handleSubmit} className="space-y-6 ">

                            {/* Tên thiết bị */}
                            <div>
                                <label className=" font-semibold mb-1">
                                    {t('f2astep1')}
                                </label>
                                <input
                                    type="text"
                                    placeholder={t('Devicename') + ' *'}
                                    className="w-full px-4 py-2 border border-zinc-700 rounded text-sm focus:outline-none focus:ring focus:border-blue-500"
                                    value={deviceName}
                                    onChange={(e) => setDeviceName(e.target.value)}
                                    required
                                />
                            </div>

                            {/* Mã QR */}
                            <div>
                                <label className=" font-semibold mb-2">
                                    {t('f2astep2')}
                                </label>
                                <div className="flex items-start gap-4">
                                    <QRCode
                                        className='w-28 h-28'
                                        errorLevel="H"
                                        value={getRandomAuthUrl(mail)}
                                    />
                                    <div className="text-sm space-y-1 mt-1">
                                        <p>
                                            {t('allowedApp')}
                                        </p>
                                        <p className="text-blue-400">
                                            {t('allowedAppList')}
                                        </p>
                                        <a href="#" className="text-blue-500 underline block">{t('cantScanQR')}</a>
                                        <a href="#" className="text-blue-500 underline block">
                                            {t('Troubleshooting')}
                                        </a>
                                    </div>
                                </div>
                            </div>

                            {/* Mã OTP */}
                            <div>
                                <label className=" font-semibold mb-1">
                                    {t('f2astep3')}
                                </label>
                                <input
                                    type="text"
                                    placeholder="Mã dùng một lần *"
                                    className="w-full px-4 py-2 border border-zinc-700 rounded text-sm focus:outline-none focus:ring focus:border-blue-500"
                                    value={otpCode}
                                    onChange={(e) => setOtpCode(e.target.value)}
                                    required
                                />
                            </div>

                            {/* Nút Gửi / Hủy */}
                            <div className="flex justify-between items-center pt-2">
                                <button
                                    type="submit"
                                    className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-6 rounded text-sm"
                                >
                                    {t('Send')}
                                </button>
                                <button
                                    type="button"
                                    className="text-gray-300 hover:underline text-sm"
                                    onClick={() => {
                                        setDeviceName('');
                                        setOtpCode('');
                                        setOpen(false);
                                        if (onClose) {
                                            onClose();
                                        }
                                    }}
                                >
                                    {t("Cancel")}
                                </button>
                            </div>
                        </form>
                    </div>
                </Modal>

            </>

        )
            : type === 'edit' ? (
                <>
                    <a href="#" className="btn btn-sm btn-secondary ms-2" data-bs-toggle="modal" data-bs-target="#modal_2fa_add" onClick={() => {
                        setOpen(true);
                        setDeviceName('');
                        setOtpCode('');
                    }}>
                        {t("Addnew")}
                    </a>
                    <Modal
                        title={
                            <div className="text-lg font-semibold text-gray-800">
                                {title}
                            </div>
                        }
                        centered
                        onCancel={handleCancel}
                        confirmLoading={confirmLoading}
                        open={open}
                        footer={null}
                        width={{
                            xs: '90%',
                            sm: '80%',
                            md: '650%',
                            lg: '50%',
                            xl: '50%',
                            xxl: '40%',
                        }}
                    >
                        <div className="w-full mx-auto bg-white shadow-md rounded-md p-3">
                            <form onSubmit={handleSubmit} className="space-y-6">

                                {/* Tên thiết bị */}
                                <div>
                                    <label className="block font-semibold mb-1">
                                        {t('f2astep1')}
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="Tên thiết bị *"
                                        className="w-full px-4 py-2 border border-zinc-700 rounded text-sm focus:outline-none focus:ring focus:border-blue-500"
                                        value={deviceName}
                                        onChange={(e) => setDeviceName(e.target.value)}
                                        required
                                    />
                                </div>

                                {/* Mã QR */}
                                <div>
                                    <label className="block font-semibold mb-2">
                                        {t('f2astep2')}
                                    </label>
                                    <div className="flex items-start gap-4">
                                        <QRCode
                                            className='w-28 h-28'
                                            errorLevel="H"
                                            value={getRandomAuthUrl(mail)} />
                                        <div className="text-sm space-y-1 mt-1">
                                            <p>{t('allowedApp')}</p>
                                            <p className="text-blue-400">
                                                {t('allowedAppList')}
                                            </p>
                                            <a href="#" className="text-blue-500 underline block">{t('cantScanQR')}</a>
                                            <a href="#" className="text-blue-500 underline block">{t('Troubleshooting')}</a>
                                        </div>
                                    </div>
                                </div>

                                {/* Mã OTP */}
                                <div>
                                    <label className="block font-semibold mb-1">
                                        {t('f2astep3')}
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="Mã dùng một lần *"
                                        className="w-full px-4 py-2 border border-zinc-700 rounded text-sm focus:outline-none focus:ring focus:border-blue-500"
                                        value={otpCode}
                                        onChange={(e) => setOtpCode(e.target.value)}
                                        required
                                    />
                                </div>

                                {/* Nút Gửi / Hủy */}
                                <div className="flex justify-between items-center pt-2">
                                    <button
                                        type="submit"
                                        className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-6 rounded text-sm"
                                    >
                                        {t('Send')}
                                    </button>
                                    <button
                                        type="button"
                                        className="text-gray-300 hover:underline text-sm"
                                        onClick={() => {
                                            setDeviceName('');
                                            setOtpCode('');
                                            setOpen(false);
                                            if (onClose) {
                                                onClose();
                                            }
                                        }}
                                    >
                                        {t("Cancel")}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </Modal>

                </>
            ) : (

                <>

                    <button className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 text-sm font-medium" onClick={
                        () => {
                            setOpen(true);
                            setDeviceName('');
                            setOtpCode('');
                            if (onClick) {
                                onClick();
                            }
                        }
                    } disabled={disabled}>
                        {t('continueActive2FA')}
                    </button>
                    <Modal
                        title={
                            <div className="text-lg font-semibold text-gray-800">
                                {title}
                            </div>
                        }
                        centered
                        onCancel={handleCancel}
                        confirmLoading={confirmLoading}
                        open={open}
                        footer={null}
                        width={{
                            xs: '90%',
                            sm: '80%',
                            md: '650%',
                            lg: '50%',
                            xl: '50%',
                            xxl: '40%',
                        }}
                    >
                        <div className="w-full mx-auto bg-white shadow-md rounded-md p-3">
                            <form onSubmit={handleSubmit} className="space-y-6 ">

                                {/* Tên thiết bị */}
                                <div>
                                    <label className="block font-semibold mb-1">
                                        {t('f2astep1')}
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="Tên thiết bị *"
                                        className="w-full px-4 py-2 border border-zinc-700 rounded text-sm focus:outline-none focus:ring focus:border-blue-500"
                                        value={deviceName}
                                        onChange={(e) => setDeviceName(e.target.value)}
                                        required
                                    />
                                </div>

                                {/* Mã QR */}
                                <div>
                                    <label className="block font-semibold mb-2">
                                        {t('f2astep2')}
                                    </label>
                                    <div className="flex items-start gap-4">
                                        <QRCode
                                            className='w-28 h-28'
                                            errorLevel="H"
                                            value={getRandomAuthUrl(mail)}
                                        />
                                        <div className="text-sm space-y-1 mt-1">
                                            <p>{t('allowedApp')}</p>
                                            <p className="text-blue-400">
                                                {t('allowedAppList')}
                                            </p>
                                            <a href="#" className="text-blue-500 underline block">{t('cantScanQR')}</a>
                                            <a href="#" className="text-blue-500 underline block">{t('Troubleshooting')}</a>
                                        </div>
                                    </div>
                                </div>

                                {/* Mã OTP */}
                                <div>
                                    <label className="block font-semibold mb-1">
                                        {t('f2astep3')}
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="Mã dùng một lần *"
                                        className="w-full px-4 py-2 border border-zinc-700 rounded text-sm focus:outline-none focus:ring focus:border-blue-500"
                                        value={otpCode}
                                        onChange={(e) => setOtpCode(e.target.value)}
                                        required
                                    />
                                </div>

                                {/* Nút Gửi / Hủy */}
                                <div className="flex justify-between items-center pt-2">
                                    <button
                                        type="submit"
                                        className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-6 rounded text-sm"
                                    >
                                        {t('Send')}
                                    </button>
                                    <button
                                        type="button"
                                        className="text-gray-300 hover:underline text-sm"
                                        onClick={() => {
                                            setDeviceName('');
                                            setOtpCode('');
                                            setOpen(false);
                                            if (onClose) {
                                                onClose();
                                            }
                                        }}
                                    >
                                        {t("Cancel")}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </Modal>

                </>
            )
    );
}